import { PermissionsEnum } from "@/auth/interfaces";
import {
  a11yProps,
  EstadoPreventaEnum,
  sizeTab,
  texto,
  useCheckPermissions,
} from "@/shared";
import { CustomTabPanel, SingleTableBoxScene } from "@/shared/components/ui";
import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import TablePreventa from "./page/preventa-espera/TablePreventa";
import PreventaSolicitudLiberacionValorInstalacionPage from "./page/preventa-solicitud-valor-instalacion/PreventaSolicitudLiberacionValorInstalacionPage";

export default function PreventasPagina() {
  useCheckPermissions(PermissionsEnum.api_view_preventa);
  const [valueTab, setValueTab] = useState(0);

  return (
    <SingleTableBoxScene title={"Preventas"} visibleReport={true}>
      <Box
        sx={{
          bgcolor: "background.paper",
          maxWidth: sizeTab,
          paddingBottom: 2,
        }}
      >
        <Tabs
          value={valueTab}
          onChange={(_event: React.SyntheticEvent, newValue: number) => {
            setValueTab(newValue);
          }}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          aria-label="scrollable force tabs preventa"
        >
          <Tab label={"Preventas"} {...a11yProps(0)} />
          <Tab label={texto.realizadas} {...a11yProps(1)} />
          <Tab label={texto.cancelado} {...a11yProps(2)} />
          <Tab label={"Valor Instalación"} {...a11yProps(3)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={valueTab} index={0}>
        <TablePreventa estado_preventa={EstadoPreventaEnum.EN_ESPERA} />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreventa
          estado_preventa={EstadoPreventaEnum.FINALIZADO}
          enable_action={false}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablePreventa
          estado_preventa={EstadoPreventaEnum.CANCELADO}
          enable_action={false}
        />
      </CustomTabPanel>

      <CustomTabPanel value={valueTab} index={3}>
        <PreventaSolicitudLiberacionValorInstalacionPage />
      </CustomTabPanel>
    </SingleTableBoxScene>
  );
}
